import colors from '../../config/colors';

export const styles = {
    displayCardHeader: {
        backgroundColor: colors.green,
        color: colors.white,
        borderTopLeftRadius: "14px",
        borderTopRightRadius: "14px",
    },
    displaySearchContainerCardHeader: {
        backgroundColor: "#f1f7f3",
        color: colors.green,
        textAlign: "center",
        fontWeight: 700,
    },
    badgePill: {
        marginLeft: "2%"
    },
    searchCardBody: {
        maxHeight: "30rem",
        overflowY: "auto"
    },
    searchRow: {
        border: "1px solid #dce8df",
        borderRadius: "10px",
        marginBottom: "0.75rem",
        textAlign: "center",
        paddingTop: "0.55rem",
        paddingBottom: "0.55rem",
        backgroundColor: "#ffffff"
    },
    status: {
        fontSize: '0.7rem',
        color: 'black',
        margin: '0.2rem',
        padding: '0.1rem'
    },
    errorStyle: { 
        color: "red" ,
        fontSize: ".9rem",
        marginTop: 0,
    },
};